<template>
	<ais-instant-search
		:search-client="searchClient"
		:routing="routing"
		:index-name="searchIndex"
		class=" o-grid"
	>

		<ais-configure :filters="customFilters" :hits-per-page.camel="perPage"></ais-configure>

		<div class="o-grid__item">
			<div class="h-margin--sm c-filters">
				<div class="c-filters__main">

					<ais-menu-select
						v-for="filter in filtersArray"
						:attribute="filter.id"
						class="c-form-field--select h-colspan--431"
						:sort-by="['name:asc']"
						:transform-items="removeEmpty"
					>
						<template v-slot="{ items, refine }">
							<div class="c-form-field--select">
								<label class="c-form-field__legend">{{  filter.label }}</label>
								<div class="c-form-field__inputset">
									<div class="c-form-field__input">

										<select @change="refine($event.currentTarget.value); applyFilter($event.currentTarget)">
											<option class="c-form-field__pseudo-label" value="">All</option>
											<option
												v-for="item in items"
												:key="item.value"
												:value="item.value"
												:selected="item.isRefined"
												class="c-form-field__option"
											>
												{{ removePrefix(item.label) }}
											</option>
										</select>
									</div>
								</div>
							</div>
						</template>
					</ais-menu-select>
				</div>

				<ais-clear-refinements v-if="filtersArray" :excluded-attributes="[]">
					<template v-slot="{ refine }">
						<button
							class="o-button o-button--regular o-button--secondary"
							@click.prevent="
								refine();
								clearFilters($event.currentTarget);
							"
						>
							<span class="o-button__text">Clear all</span>
					</button>
					</template>
				</ais-clear-refinements>
			</div>
		</div>


		<ais-state-results
			v-if="featuredItemsArray"
			class="o-grid__item o-grid o-grid--contained c-feed c-feed--large"
		>
			<template v-slot="{ state: { page } }">
				<section v-if="page < 1" class="h-margin--sm o-grid__item c-feed__inner">
					<ol class="o-list c-feed__list">
						<li
							v-for="item in featuredItemsArray"
							:key="item"
							class="c-feed__item"
						>
							<a class="c-media c-media--link" :href="item.uri">
								<div class="c-media__image" v-if="item.image">
									<div class="o-image">
										<img
											class="o-image__img"
											:src="item.image.src"
											alt=""
											:width="item.image.width"
											:height="item.image.height"
										>
									</div>
								</div>
								<h3 class="c-media__title">
									{{ item.title }}
								</h3>
								<p class="c-media__posttitle"
									v-if="item.postTitle"
								>{{ item.postTitle }}</p>
								<p class="c-media__summary o-text">
									{{ item.summary }}
								</p>
								<div
									v-if="item.eventFlag && item.eventFlag != 'None'"
									class="c-media__flag"
									v-html="item.eventFlag"
								></div>
								<div class="c-media__footer">
									<span
										v-if="item.meta"
										class="c-media__footer-meta"
									>{{ item.meta }}</span>
									<div class="c-media__actions">
										<div class="o-button o-button--secondary">
											Find out more
										</div>
									</div>
								</div>
							</a>
						</li>
					</ol>
				</section>
				<div v-else></div>
			</template>
		</ais-state-results>


		<ais-state-results class="h-margin--sm o-grid__item c-feed" :class="feedClass">
			<template v-slot="{ results: { hits } }">
				<ais-hits v-if="hits.length > 0"
					:class-names=" {
						'ais-Hits': 'c-feed__inner',
						'ais-Hits-list': 'o-list c-feed__list',
						'ais-Hits-item': 'c-feed__item',
					}
				">

					<template v-slot:item="{ item }">
						<a class="c-media c-media--link" :href="item.uri">
							<div class="c-media__image" v-if="item.searchImage">
								<div class="o-image">
									<img class="o-image__img" :src="item.searchImage" alt="">
								</div>
							</div>
							<h3 class="c-media__title" v-html="item.title"></h3>
							<p class="c-media__posttitle"
								v-if="filtersArray.length > 1"
								v-html="joinFilters(item[filtersArray[1].id])"
							></p>
							<p class="c-media__summary o-text" v-html="item.summary"></p>
							<div
								v-if="item.eventFlag && item.eventFlag != 'None'"
								class="c-media__flag"
								v-html="item.eventFlag"
							></div>
							<div class="c-media__footer">
								<span
									v-if="filtersArray.length"
									v-html="joinFilters(item[filtersArray[0].id])"
									class="c-media__footer-meta"
								></span>
								<div class="c-media__actions">
									<div class="o-button o-button--secondary">
										Find out more
									</div>
								</div>
							</div>
						</a>
					</template>
				</ais-hits>

				<div v-else class="o-block">
					No results have been found.
				</div>

				<div class="o-grid__item o-block" v-if="hits.length > 0">
					<nav class="c-pagination" aria-label="Pagination">
						<ais-pagination v-on:page-change="pageChange()" :padding="2">
							<template
								v-slot="{
									currentRefinement,
									nbPages,
									pages,
									isFirstPage,
									isLastPage,
									refine,
									createURL
								}"
							>
								<ul class="c-pagination__list">
									<li class="c-pagination__item c-pagination__first">
										<a
											class="c-pagination__link"
											:class="{'is-disabled':isFirstPage}"
											:href="createURL(0)"
											@click.prevent="refine(0)"
										>
											First
										</a>
									</li>
									<li class="c-pagination__item c-pagination__prev">
										<a
											:href="createURL(currentRefinement - 1)"
											@click.prevent="refine(currentRefinement - 1)"
											class="c-pagination__link"
											:class="{'is-disabled':isFirstPage}"
											aria-label="Previous"
										>
											<span class="icon">
												<chevronLeft />
											</span>
										</a>
									</li>
									<li
										class="c-pagination__item"
										:class="[page == currentRefinement ? 'c-pagination__current' : '']"
										v-for="page in pages"
										:key="page"
									>
										<a
											class="c-pagination__link"
											:class="[page == currentRefinement ? 'is-active' : '']"
											:href="createURL(page)"
											@click.prevent="refine(page)"
											v-html="page + 1"
										>
										</a>
									</li>
									<li class="c-pagination__item c-pagination__next">
										<a
											:href="createURL(currentRefinement + 1)"
											@click.prevent="refine(currentRefinement + 1)"
											class="c-pagination__link"
											:class="{'is-disabled':isLastPage}"
											aria-label="Next"
										>
											<span class="icon">
												<chevronRight />
											</span>
										</a>
									</li>
									<li class="c-pagination__item c-pagination__last">
										<a
											class="c-pagination__link"
											:class="{'is-disabled':isLastPage}"
											:href="createURL(nbPages)"
											@click.prevent="refine(nbPages)"
										>
											Last
										</a>
									</li>
								</ul>
							</template>
						</ais-pagination>
					</nav>
				</div>
			</template>
		</ais-state-results>
	</ais-instant-search>
</template>

<script>
	import { history } from "instantsearch.js/es/lib/routers";
	import { singleIndex as singleIndexMapping } from "instantsearch.js/es/lib/stateMappings";
	import {
		AisInstantSearch,
		AisConfigure,
		AisClearRefinements,
		AisCurrentRefinements,
		AisRefinementList,
		AisHits,
		AisMenuSelect,
		AisPagination,
		AisPoweredBy,
		AisSearchBox,
		AisSortBy,
		AisStateResults,
	} from "vue-instantsearch/vue3/es";
	import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

	import chevronRight from '/web/static/images/svgs/icon-chevron-right.svg?component';
	import chevronLeft  from '/web/static/images/svgs/icon-chevron-left.svg?component';

	export default {
		data() {
			return {
				routing: {
					router: history(),
					stateMapping: singleIndexMapping(this.$props.searchIndex),
				},
				searchClient: this.searchClient,
			};
		},
		props: {
			searchKey: {
				type: String,
			},
			searchNodes: {
				type: String,
			},
			searchPort: {
				type: String,
			},
			searchProtocol: {
				type: String,
			},
			searchIndex: {
				type: String,
			},
			filterData: {
				type: String
			},
			feedModifier: {
				type: String
			},
			featuredData: {
				type: String
			},
			filterSection: {
				type: String,
				default: "news"
			},
			filterOperator: {
				type: String,
				default: "&&"
			},
			perPage: {
				type: Number,
				default: 16
			},
			sortBy: {
				type: String,
				default: null
			}
		},
		created() {
			const splitNodes = this.$props.searchNodes.split(";");

			const mappedNodes = splitNodes.map((node) => ({
				host: node,
				port: this.$props.searchPort,
				protocol: this.$props.searchProtocol,
			}));

			const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
				server: {
					apiKey: this.$props.searchKey, // Be sure to use an API key that only allows search operations
					nodes: mappedNodes,
				},
				additionalSearchParameters: {
					query_by: "title",
					sort_by: this.sortBy
				},
			});

			this.searchClient = typesenseInstantsearchAdapter.searchClient;
		},
		computed: {
			customFilters: function () {
				const displayFilter = `hideFromListing:!=true`;
				const typeFilter = `type:=${this.filterSection}`;

				return typeFilter + this.filterOperator + displayFilter;
			},
			filtersArray: function () {
				return this.filterData ? JSON.parse(this.filterData) : null;
			},
			featuredItemsArray: function () {
				return this.featuredData ? JSON.parse(this.featuredData) : null;
			},
			feedClass: function () {
				return this.feedModifier ? `c-feed--${this.feedModifier}` : null;
			}
		},
		components: {
			AisInstantSearch,
			AisConfigure,
			AisClearRefinements,
			AisCurrentRefinements,
			AisRefinementList,
			AisHits,
			AisMenuSelect,
			AisPagination,
			AisPoweredBy,
			AisSearchBox,
			AisSortBy,
			AisStateResults,
			chevronRight,
			chevronLeft,
		},
		methods: {
			pageChange() {
				const topOfResults = document.querySelector('.c-filters__main');
				window.scrollTo(topOfResults.offsetLeft, topOfResults.offsetTop);
			},
			removePrefix(label) {
				// split on `__` to remove number prefix, e.g `01__`
				return label.split('__')[label.split('__').length - 1];
			},
			joinFilters(array) {
				// apply removePrefix() then join with commas
				const filters = array.map((x) => this.removePrefix(x));
				return filters.join(', ');
			}
		}
	};
</script>
